import { FC } from 'react';
import { useGetFcos } from '../../../api/fcos';
import { DataSourceFCOFields, WorkspaceFCOContainer } from '../../../core/types/fcoTypes';
import { Empty, Loading } from '@lithos';
import { useUserSettings } from '../../context/UserSettingsContext';
import { IngestServerGroup } from '../../../types/tecton_proto/servergroupservice/server_group_service';
import DataSourcesList from '../sources/DataSourcesList';

const IngestServerGroupSourcesTableView: FC<{ serverGroup: IngestServerGroup }> = ({ serverGroup }) => {
  const { workspace } = useUserSettings();

  const { data, isLoading, isError } = useGetFcos(workspace ?? '', {
    select: (data: WorkspaceFCOContainer) => {
      return {
        sources: data?.dataSources.filter((source) => {
          return source[DataSourceFCOFields.INGEST_SERVER_GROUP_ID] === serverGroup.id;
        }),
        idToFcoMap: data.idToFcoMap,
      };
    },
  });

  if (isLoading) {
    return <Loading />;
  }

  if (isError) {
    return (
      <Empty
        placement="full-page"
        actions={[]}
        useCase="errorUnknown"
        title="Unknown Error"
        description="Error loading feature views"
      />
    );
  }

  return (
    <DataSourcesList items={data?.sources ?? []} idToFcoMap={data?.idToFcoMap ?? {}} workspace={workspace ?? ''} />
  );
};

export default IngestServerGroupSourcesTableView;
